module.exports = __webpack_public_path__ + "static/media/jakub-designer.69a7c2c9.png";